import * as batshit from "@yornaath/batshit";
import {PredefinedControlId} from "platformed-client/types";
import api from "../../../api";
import {param, typedQuery} from "../../typing";
import {resolver, scheduler} from "../../batch";

const controls = batshit.create({
  fetcher: api.tprm.controls.load,
  resolver: resolver("predefined_control_id"),
  scheduler,
});

export const control = typedQuery(["tprm", "control", param<PredefinedControlId>("controlId")], async controlId => {
  return await controls.fetch(controlId);
});
